import { z } from 'zod';

import { CREATE_SIX_DESCRIPTION_MAX_LENGTH, CREATE_SIX_NAME_MAX_LENGTH } from '@/constants';

export const newExternalUserSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
  phoneNumber: z.string().min(1, 'Phone number is required'),
  department: z.string().optional(),
});

export const createSixSchema = z.object({
  name: z
    .string()
    .min(1, 'SIX name is required')
    .max(CREATE_SIX_NAME_MAX_LENGTH, `SIX name must be ${CREATE_SIX_NAME_MAX_LENGTH} characters or fewer`),
  description: z
    .string()
    .max(CREATE_SIX_DESCRIPTION_MAX_LENGTH, `Description must be ${CREATE_SIX_DESCRIPTION_MAX_LENGTH} characters or fewer`),
  ownerIds: z.array(z.string()).min(1, 'At least one owner is required'),
  internalParticipantIds: z.array(z.string()),
  externalParticipantIds: z.array(z.string()),
  newExternalUsers: z.array(newExternalUserSchema),
});
